<template>
  <div>
    <h2 class="step-name"> Client Details </h2>

    <div class="step-section">

      <text-input label="Client Code"
                  field-name="client_code"
                  disabled>
      </text-input>

      <text-input label="Company"
                  field-name="company"
                  disabled>
      </text-input>

      <text-input label="Name"
                  field-name="full_name"
                  disabled>
      </text-input>

      <text-input label="Farm Group Name"
                  field-name="farm_group_name"
                  disabled>
      </text-input>

      <text-input label="Last Winter Consult Year"
                  field-name="previous_winter_consult_year"
                  disabled>
      </text-input>

      <text-input label="Zone"
                  field-name="zone"
                  disabled>
      </text-input>

      <text-input label="Email Notification Zone"
                  field-name="email_notification_zone"
                  disabled>
      </text-input>

      <text-input label="Address"
                  field-name="full_address"
                  disabled>
      </text-input>

      <text-input label="Phone"
                  field-name="phone"
                  disabled>
      </text-input>

      <text-input label="Mobile"
                  field-name="mobile"
                  disabled>
      </text-input>

      <text-input label="E-Mail"
                  field-name="email"
                  disabled>
      </text-input>

    </div>

    <div class="bad_allocations" v-if='this.hasBadClientDrugAllocations'>
      <div class="alert alert-danger">
        Warning: Client drug purchases have been detected that are not
        associated with a KVC consult shed/farm. These are listed below. These
        drug purchases will not appear in the consult information. Please
        review and if needed either update the sales in Ezyvet or add the
        animal to KVC farms - see farm services for help with this process.
      </div>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Client Code</th>
            <th>Purchased</th>
            <th>quantity</th>
            <th>Drug Name</th>
            <th>Animal Name</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(drug, index) in getChartData('bad_client_drug_allocations')" :key="index">
            <td class="text-left">{{ drug["client_code"] }}</td>
            <td class="text-left">{{ drug["purchased"] }}</td>
            <td class="text-left">{{ drug["quantity"] }}</td>
            <td class="text-left">{{ drug["drug_name"] }}</td>
            <td class="text-left">{{ drug["animal_name"] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import { mapGetters } from 'vuex'

export default {
  name: 'ClientDetails',
  mixins: [ baseComponent ],
  methods: {
    toggleNotifications: function() {
      this.setEmailNotification({
        slug: 'notes-for-farm-services',
        value: Boolean(this.getFieldComment('notes_for_farm_services', this.$options.name).current)
      })
    },
  },
  computed: {
    ...mapGetters('currentConsult', ['getFieldComment']),
    hasBadClientDrugAllocations: function () {
      return this.getChartData('bad_client_drug_allocations').length > 0
    },
  }
};
</script>
